<template>
  <tr>
    <td width="200">
      <strong>{{ reportDates }}</strong
      ><br />
      <span class="text-muted">id: {{ tipSplit.reportId }}</span>
    </td>
    <td>
      {{ tipSplit.status }}<br />
      <span class="text-muted">
        <span v-if="tipSplit.status == 'splitting tips'">
          {{
            Math.round(
              (tipSplit.locationsCompleted / tipSplit.locations) * 100
            )
          }}% complete
        </span>
        <span v-if="tipSplit.status == 'saving'"> saving report data </span>
        <span v-if="tipSplit.status == 'complete'">
          Split {{ tipSplit.numberOfTips }} tips from
          {{ tipSplit.locationsWithTips }} locations
        </span>
      </span>
    </td>
    <td width="350">
      {{ runBy }}<br />
      <span class="text-muted"> on {{ reportCreatedDate }} </span>
    </td>
    <td width="300">
      <router-link
        v-if="tipSplit.status == 'complete'"
        :to="`/tip-splits/${tipSplit.reportId}`"
        class="btn btn-sm btn-primary mr-2"
      >
        View Details
      </router-link>
      <a
        v-if="tipSplit.status == 'complete'"
        href="#!"
        @click.prevent="download"
        class="btn btn-sm btn-info"
      >
        download
      </a>
    </td>
  </tr>
</template>
<script>
import moment from "moment";

export default {
  async created() {
    // if in progress, auto refresh the record
    if (this.refreshStatusList.includes(this.tipSplit.status)) {
      this.refreshTimer = setInterval(() => {
        this.fetchTipSplit();
        // if we reached the desired status, clear the interval
        if (!this.refreshStatusList.includes(this.tipSplit.status)) {
          clearInterval(this.refreshTimer);
          this.refreshTimer = false;
        }
      }, this.refreshInterval);
    }
  },
  components: {},
  props: ["tipSplit"],
  data() {
    return {
      isLoading: false,
      refreshInterval: 5000,
      refreshStatusList: ["pending", "splitting tips", "saving"],
      refreshTimer: false,
    };
  },
  computed: {
    reportDates() {
      return `${this.tipSplit.startTime} - ${this.tipSplit.endTime}`;
    },
    reportCreatedDate() {
      return moment(+this.tipSplit.reportId).format("MMM Do YYYY, h:mm a");
    },
    runBy() {
      return this.tipSplit.source?.name || "";
    },
  },
  methods: {
    async fetchTipSplit() {
      console.log(`getting tip split report ${this.tipSplit.reportId}`);
      const response = await this.$store.dispatch("callAPI", {
        action: "getSplitReport",
        reportId: this.tipSplit.reportId,
      });
      // update the report record
      this.$store.commit("updateTipSplitReport", [
        this.tipSplit.reportId,
        response.data.data,
      ]);
    },
    async download() {
      this.downloading = true;
      // fetch the report to ensure we have valid download links
      await this.fetchTipSplit();
      // force download of the payroll format
      Object.values(this.tipSplit.downloads.payroll).forEach((url) => {
        window.open(url);
      });
    },
  },
};
</script>

<style lang="scss"></style>
